// extracted by mini-css-extract-plugin
export default {"main__pin":"RebnderModal_main__pin__BefKf","opt__box":"RebnderModal_opt__box__jvT9d","optCont":"RebnderModal_optCont__MfBCe","submitBtnMain":"RebnderModal_submitBtnMain__XClX7"};